
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { StrategyWithDetails } from "@/types/strategy-types";
import { transformStrategyData } from "./utils/transformData";

export const useStrategiesData = (providerId?: string | null) => {
  const [strategies, setStrategies] = useState<StrategyWithDetails[]>([]);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  const loadStrategies = async () => {
    try {
      let query = supabase
        .from('strategy')
        .select(`
          *,
          strategy_provider:strategy_provider_id (
            name
          )
        `);
        
      // If providerId is provided, filter by it
      if (providerId) {
        query = query.eq('strategy_provider_id', providerId);
      }
      
      query = query.order('created_at', { ascending: false });

      const { data, error } = await query;

      if (error) {
        console.error('Error loading strategies:', error);
        throw error;
      }
      
      // Transform data to match our expected structure
      const transformedData = transformStrategyData(data);
      
      setStrategies(transformedData || []);
      setLoading(false);
    } catch (error) {
      console.error('Error loading strategies:', error);
      toast({
        title: "Error",
        description: "Failed to load strategies",
        variant: "destructive",
      });
    }
  };

  return { 
    strategies, 
    loading, 
    loadStrategies,
    setStrategies
  };
};
